import { spacing, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-space-vertical";
const landing = objectWithClassName({
  marginBottom: spacing["3xl"],
  [`@media (${media.queries.tablet.min})`]: {
    marginBottom: spacing["6xl"]
  },
  [`@media (${media.queries.desktop.min})`]: {
    marginBottom: "120px"
  },
  className: [
    `${classNamePrefix}-landing`,
    /** @deprecated Use 'umd-layout-space-vertical-landing' instead */
    "umd-layout-vertical-landing"
  ]
});
const landingChild = objectWithClassName({
  marginBottom: spacing.lg,
  [`@media (${media.queries.tablet.min})`]: {
    marginBottom: spacing["xl"]
  },
  [`@media (${media.queries.desktop.min})`]: {
    marginBottom: spacing["2xl"]
  },
  className: [
    `${classNamePrefix}-landing-child`,
    /** @deprecated Use 'umd-layout-space-vertical-landing-child' instead */
    "umd-layout-vertical-landing-child"
  ]
});
const interior = objectWithClassName({
  marginBottom: spacing["3xl"],
  [`@media (${media.queries.desktop.min})`]: {
    marginBottom: spacing["6xl"]
  },
  className: [
    `${classNamePrefix}-interior`,
    /** @deprecated Use 'umd-layout-space-vertical-interior' instead */
    "umd-layout-vertical-interior"
  ]
});
const interiorChild = objectWithClassName({
  marginBottom: spacing.lg,
  className: [
    `${classNamePrefix}-interior-child`,
    /** @deprecated Use 'umd-layout-space-vertical-interior-child' instead */
    "umd-layout-vertical-interior-child"
  ]
});
const headlineLarge = objectWithClassName({
  marginBottom: spacing.sm,
  [`@media (${media.queries.desktop.min})`]: {
    marginBottom: spacing.md
  },
  className: [
    `${classNamePrefix}-headline-large`,
    /** @deprecated Use 'umd-layout-space-vertical-headline-large' instead */
    "umd-layout-headline-large"
  ]
});
const headlineMedium = objectWithClassName({
  marginBottom: spacing.sm,
  className: [
    `${classNamePrefix}-headline-medium`,
    /** @deprecated Use 'umd-layout-space-vertical-headline-medium' instead */
    "umd-layout-headline-medium"
  ]
});
export {
  headlineLarge,
  headlineMedium,
  interior,
  interiorChild,
  landing,
  landingChild
};
//# sourceMappingURL=vertical.js.map
